import axios from 'axios';
import { API_URL } from '../const/config';

const api = axios.create({
    baseURL: API_URL + '/api',
});

export class categoryService {
    static async getAll(): Promise<any[]> {
        const res = await api.get<any[]>('/category');
        return res.data;
    }

    static async create(payload: { name: string; description?: string }): Promise<any> {
        const res = await api.post('/category', payload);
        return res.data;
    }

    static async update(payload: { id: number, name: string; }
    ): Promise<void> {
        await api.put(`/category`, payload);
    }

    static async delete(id: number): Promise<void> {
        await api.delete(`/category/${id}`);
    }
}
